module.exports = __webpack_public_path__ + "img/cashboomerang-logo.36f1dc3e.png";